import {
  ADD_AGENTS_DATA_ERROR,
  ADD_AGENTS_DATA_LOADING,
  ADD_AGENTS_DATA_SUCCESS,
  RESET_ADD_AGENTS_DATA,
} from "../../Store/type/Constant";

let initialState = {
  loading: false,
  user: [{}],
  error: null,
  errors: null,
  success: false,
  // payload: {}
};

export default function createAgentsReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_AGENTS_DATA_LOADING:
      return { ...state, error: false, loading: true, success: false };

    case ADD_AGENTS_DATA_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        success: true,
        message: action.msg,
      };

    case ADD_AGENTS_DATA_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
        errors: action.errors,
        success: false,
      };
    case RESET_ADD_AGENTS_DATA:
      return {
        ...state,
        error: false,
        loading: false,
        success: false,
        errors: [],
        user: [],
      };

    default:
      return state;
  }
}
